/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global" ;
    import * as helper from "../../js/helper";
	import like_component from "../components/like-component.vue";
    const __vue_script__ ={
        components: {
        },
		name:'property_information_component',
        props: {
            property_json: {
                type: String,
            },
            property_data: {
                type: Object,
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading: false,
                property: null,
                ad_type_color: '#0000ff',
                ad_type_color_wt: '#0000ff',
                property_type_icon: '#0000ff',
                creation_date: new Date(),
			};
		},
        mounted(){
            if(this.property_json != undefined)
                this.property = JSON.parse(this.property_json);
            else
                this.property = this.property_data;
            this.is_loading = true;
            this.creation_date = new Date(this.property.creation);
            this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];
            this.ad_type_color_wt = global.global_params.ad_type_colors[this.property.ad_type]+"aa";
            this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];
            this.is_loading = false;
        },
		methods: {
			check_enabled: function(field){
				if (this.property.property_type=="")
					return false;
				return this.enabled_fields.includes(field);
			},
            year_string: function(year_count){
                if(year_count == 0) return 'New';
                else if(year_count == 1) return 'Year';
                else if(year_count == 2) return '2 Years';
                else if(year_count > 10) return '{0} Years_';
                else return '{0} Years';
            }
		},
		computed:{
            enabled_fields(){
                var fields = global.property_constants.property_types[this.property.property_type];
                global.property_constants.remove_field[this.property.ad_type].forEach(field => {
                    const index = fields.indexOf(field);
                    if (index > -1) { // only splice array when item is found
                        fields.splice(index, 1); // 2nd parameter means remove one item only
                    }
                });
                if(this.is_child){
                    global.property_constants.remove_child_field.forEach(field => {
                        const index = fields.indexOf(field);
                        if (index > -1) { // only splice array when item is found
                            fields.splice(index, 1); // 2nd parameter means remove one item only
                        }
                    });
                }
                return fields;
            }
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.property
    ? _c("div", [
        _c("div", { staticClass: "row g-0 mt-3" }, [
          _c(
            "ul",
            {
              staticClass:
                "d-flex m-0 justify-content-between propertyPriceBedRangeInfoContainer"
            },
            [
              _vm.property.rega_data.propertyFace &&
              _vm.property.rega_data.propertyFace != ""
                ? _c("li", { staticClass: "priceBedRangeInfoInnerContainer" }, [
                    _c("p", {}, [_vm._v(_vm._s(_vm.helper.t("propertyFace")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "fw-bold mt-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.helper.t(_vm.property.rega_data.propertyFace)
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.property["property_for"] && _vm.property["property_for"] != ""
                ? _c("li", { staticClass: "priceBedRangeInfoInnerContainer" }, [
                    _c("p", {}, [
                      _vm._v(_vm._s(_vm.helper.t("propertyUsages")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      _vm._l(_vm.property["property_for"], function(
                        property_for
                      ) {
                        return _c(
                          "span",
                          {
                            staticClass: "badge bg-secondary mx-1 fs-6 fw-bold"
                          },
                          [_vm._v(_vm._s(_vm.helper.t(property_for)))]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.check_enabled("street_width") &&
              _vm.property["street_width"] &&
              !_vm.property["parent_property"]
                ? _c("li", { staticClass: "priceBedRangeInfoInnerContainer" }, [
                    _c("p", {}, [_vm._v(_vm._s(_vm.helper.t("Street Width")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "fw-bold mt-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.helper.t("{0}m", [_vm.property["street_width"]])
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.property["age"] != 0
                ? _c("li", { staticClass: "priceBedRangeInfoInnerContainer" }, [
                    _c("p", {}, [_vm._v(_vm._s(_vm.helper.t("Age")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "fw-bold mt-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.helper.t(
                            _vm.global.global_params.ages[_vm.property["age"]]
                          )
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.check_enabled("size") && _vm.property["size"] > 0
                ? _c("li", { staticClass: "priceBedRangeInfoInnerContainer" }, [
                    _c("p", {}, [_vm._v(_vm._s(_vm.helper.t("Size")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "fw-bold mt-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.helper.t("{0} sq.m.", [_vm.property["size"]])
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.property["front"] > 0 && _vm.property["side"]
                ? _c("li", { staticClass: "priceBedRangeInfoInnerContainer" }, [
                    _c("p", {}, [
                      _vm._v(_vm._s(_vm.helper.t("Width x Length")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "fw-bold mt-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.helper.t("{0}m × {1}m", [
                            _vm.property["side"],
                            _vm.property["front"]
                          ])
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.check_enabled("floor_num")
                ? _c("li", { staticClass: "priceBedRangeInfoInnerContainer" }, [
                    _c("p", {}, [_vm._v(_vm._s(_vm.helper.t("Floor No")))]),
                    _vm._v(" "),
                    _vm.property["floor_num"] == 0
                      ? _c("p", { staticClass: "fw-bold mt-2" }, [
                          _vm._v(_vm._s(_vm.helper.t("Ground")))
                        ])
                      : _c("p", { staticClass: "fw-bold mt-2" }, [
                          _vm._v(_vm._s(_vm.property["floor_num"]))
                        ])
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row g-0 mt-1 mb-2" }, [
          _c(
            "ul",
            {
              staticClass:
                "d-flex justify-content-between propertyPriceBedRangeInfoContainer mb-0"
            },
            [
              _vm.property["floors"].length > 0
                ? _vm._l(_vm.property["children_types"], function(
                    child,
                    child_type
                  ) {
                    return _c(
                      "li",
                      { staticClass: "priceBedRangeInfoInnerContainer" },
                      [
                        _c("p", { staticClass: "fw-bold mt-2" }, [
                          _vm._v(_vm._s(_vm.helper.t(child_type)))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row g-0 mt-2" }, [
                          _c(
                            "ul",
                            {
                              staticClass:
                                "d-flex justify-content-between propertyPriceBedRangeInfoContainer"
                            },
                            [
                              _c(
                                "li",
                                {
                                  staticClass: "priceBedRangeInfoInnerContainer"
                                },
                                [
                                  _c("p", {}, [
                                    _vm._v(_vm._s(_vm.helper.t("Total_SP")))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "fw-bold mt-2" }, [
                                    _vm._v(_vm._s(child["total"]))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "priceBedRangeInfoInnerContainer"
                                },
                                [
                                  _vm.property["ad_type"] == "Rent"
                                    ? _c("p", {}, [
                                        _vm._v(
                                          _vm._s(_vm.helper.t("Yearly Rent"))
                                        )
                                      ])
                                    : _c("p", {}, [
                                        _vm._v(
                                          _vm._s(_vm.helper.t("Sale Price"))
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "fw-bold mt-2" }, [
                                    _vm._v(_vm._s(child["total_price"]))
                                  ])
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  })
                : [
                    _vm.check_enabled("no_apartment") &&
                    _vm.property["no_apartment"] > 0
                      ? _c(
                          "li",
                          { staticClass: "priceBedRangeInfoInnerContainer" },
                          [
                            _c("p", {}, [
                              _vm._v(_vm._s(_vm.helper.t("Apartments")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "fw-bold mt-2" }, [
                              _vm._v(_vm._s(_vm.property["no_apartment"]))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.check_enabled("no_shop") && _vm.property["no_shop"] > 0
                      ? _c(
                          "li",
                          { staticClass: "priceBedRangeInfoInnerContainer" },
                          [
                            _c("p", {}, [
                              _vm._v(_vm._s(_vm.helper.t("Shops/Offices")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "fw-bold mt-2" }, [
                              _vm._v(_vm._s(_vm.property["no_shop"]))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.property["ad_type"] == "Rent"
                      ? _c(
                          "li",
                          { staticClass: "priceBedRangeInfoInnerContainer" },
                          [
                            _c("p", {}, [
                              _vm._v(_vm._s(_vm.helper.t("Rent Type")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "fw-bold mt-2" }, [
                              _vm._v(
                                _vm._s(_vm.helper.t(_vm.property["rent_type"]))
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.property["ad_type"] == "Rent"
                      ? _c(
                          "li",
                          { staticClass: "priceBedRangeInfoInnerContainer" },
                          [
                            _c("p", {}, [
                              _vm._v(_vm._s(_vm.helper.t("Yearly Rent")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "fw-bold mt-2" }, [
                              _vm._v(
                                _vm._s(_vm.property["yearly_price"].toFixed(0))
                              )
                            ])
                          ]
                        )
                      : _c(
                          "li",
                          { staticClass: "priceBedRangeInfoInnerContainer" },
                          [
                            _c("p", {}, [
                              _vm._v(_vm._s(_vm.helper.t("Total Price")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "fw-bold mt-2" }, [
                              _vm._v(
                                _vm._s(_vm.property["total_price"].toFixed(0))
                              )
                            ])
                          ]
                        ),
                    _vm._v(" "),
                    _vm.check_enabled("no_bed") && _vm.property["no_bed"] > 0
                      ? _c(
                          "li",
                          { staticClass: "priceBedRangeInfoInnerContainer" },
                          [
                            _c("p", {}, [
                              _vm._v(_vm._s(_vm.helper.t("Bedrooms")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "fw-bold mt-2" }, [
                              _vm._v(_vm._s(_vm.property["no_bed"]))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.check_enabled("no_bath") && _vm.property["no_bath"] > 0
                      ? _c(
                          "li",
                          { staticClass: "priceBedRangeInfoInnerContainer" },
                          [
                            _c("p", {}, [
                              _vm._v(_vm._s(_vm.helper.t("Bathrooms")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "fw-bold mt-2" }, [
                              _vm._v(_vm._s(_vm.property["no_bath"]))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.check_enabled("no_living") &&
                    _vm.property["no_living"] > 0
                      ? _c(
                          "li",
                          { staticClass: "priceBedRangeInfoInnerContainer" },
                          [
                            _c("p", {}, [
                              _vm._v(_vm._s(_vm.helper.t("Livingrooms")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "fw-bold mt-2" }, [
                              _vm._v(_vm._s(_vm.property["no_living"]))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.check_enabled("for_type") && _vm.property["for_type"]
                      ? _c(
                          "li",
                          { staticClass: "priceBedRangeInfoInnerContainer" },
                          [
                            _c("p", {}, [
                              _vm._v(_vm._s(_vm.helper.t("Property for")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "fw-bold mt-2" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.helper.t(
                                    _vm.property["for_type"] == "Single"
                                      ? "Singles"
                                      : _vm.property["for_type"]
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-23f80d3f_0", { source: "\n.icon{\n    width:10%;\n}\n.properties-img .image-holder{\n    display: block;\n    padding-top: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/components/property-information-component.vue"],"names":[],"mappings":";AAmLA;IACA,SAAA;AACA;AACA;IACA,cAAA;IACA,iBAAA;IACA,4BAAA;IACA,sBAAA;IACA,2BAAA;AACA","file":"property-information-component.vue","sourcesContent":["<template>\r\n\t<div v-if=\"property\">\r\n        <div class=\"row g-0 mt-3\">\r\n            <ul class=\"d-flex m-0 justify-content-between propertyPriceBedRangeInfoContainer\">\r\n                <li v-if=\"property.rega_data.propertyFace && property.rega_data.propertyFace!=''\" class=\"priceBedRangeInfoInnerContainer\">\r\n                    <p class=\"\">{{ helper.t(\"propertyFace\") }}</p>\r\n                    <p class=\"fw-bold mt-2\">{{ helper.t(property.rega_data.propertyFace) }}</p>\r\n                </li>\r\n                <li v-if=\"property['property_for'] && property['property_for'] != ''\" class=\"priceBedRangeInfoInnerContainer\">\r\n                    <p class=\"\">{{ helper.t(\"propertyUsages\") }}</p>\r\n                    <div class=\"d-flex justify-content-center\">\r\n                        <span v-for=\"property_for in property['property_for']\" class=\"badge bg-secondary mx-1 fs-6 fw-bold\">{{ helper.t(property_for) }}</span>\r\n                    </div>\r\n                </li>\r\n                <li v-if=\"check_enabled('street_width') && property['street_width'] && !property['parent_property']\" class=\"priceBedRangeInfoInnerContainer\">\r\n                    <p class=\"\">{{ helper.t(\"Street Width\") }}</p>\r\n                    <p class=\"fw-bold mt-2\">{{ helper.t(\"{0}m\",[property['street_width']]) }}</p>\r\n                </li>\r\n                <li v-if=\"property['age'] != 0\" class=\"priceBedRangeInfoInnerContainer\">\r\n                    <p class=\"\">{{ helper.t(\"Age\") }}</p>\r\n                    <p class=\"fw-bold mt-2\">{{ helper.t(global.global_params.ages[property['age']]) }}</p>\r\n                </li>\r\n                <li v-if=\"check_enabled('size') && property['size'] > 0\" class=\"priceBedRangeInfoInnerContainer\">\r\n                    <p class=\"\">{{ helper.t(\"Size\") }}</p>\r\n                    <p class=\"fw-bold mt-2\">{{ helper.t(\"{0} sq.m.\",[property['size']]) }}</p>\r\n                </li>\r\n                <li v-if=\"property['front'] > 0 && property['side']\" class=\"priceBedRangeInfoInnerContainer\">\r\n                    <p class=\"\">{{ helper.t(\"Width x Length\") }}</p>\r\n                    <p class=\"fw-bold mt-2\">{{ helper.t(\"{0}m × {1}m\",[property['side'],property['front']]) }}</p>\r\n                </li>\r\n                <li v-if=\"check_enabled('floor_num')\" class=\"priceBedRangeInfoInnerContainer\">\r\n                    <p class=\"\">{{ helper.t(\"Floor No\") }}</p>\r\n                    <p v-if=\"property['floor_num'] == 0\" class=\"fw-bold mt-2\">{{ helper.t(\"Ground\") }}</p>\r\n                    <p v-else class=\"fw-bold mt-2\">{{ property['floor_num'] }}</p>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div class=\"row g-0 mt-1 mb-2\">\r\n            <ul class=\"d-flex justify-content-between propertyPriceBedRangeInfoContainer mb-0\">\r\n                <template v-if=\"property['floors'].length > 0\">\r\n                    <li v-for=\"(child,child_type) in property['children_types']\" class=\"priceBedRangeInfoInnerContainer\">\r\n                        <p class=\"fw-bold mt-2\">{{ helper.t(child_type) }}</p>\r\n                        <div class=\"row g-0 mt-2\">\r\n                            <ul class=\"d-flex justify-content-between propertyPriceBedRangeInfoContainer\">\r\n                                <li class=\"priceBedRangeInfoInnerContainer\">\r\n                                    <p class=\"\">{{ helper.t(\"Total_SP\") }}</p>\r\n                                    <p class=\"fw-bold mt-2\">{{ child[\"total\"] }}</p>\r\n                                </li>\r\n                                <li class=\"priceBedRangeInfoInnerContainer\">\r\n                                    <p v-if=\"property['ad_type'] == 'Rent'\" class=\"\">{{ helper.t(\"Yearly Rent\") }}</p>\r\n                                    <p v-else class=\"\">{{ helper.t(\"Sale Price\") }}</p>\r\n                                    <p class=\"fw-bold mt-2\">{{ child[\"total_price\"] }}</p>\r\n                                </li>\r\n                            </ul>\r\n                        </div>\r\n                    </li>\r\n                </template>\r\n                <template v-else>\r\n                    <li v-if=\"check_enabled('no_apartment') && property['no_apartment'] > 0\" class=\"priceBedRangeInfoInnerContainer\">\r\n                        <p class=\"\">{{ helper.t(\"Apartments\") }}</p>\r\n                        <p class=\"fw-bold mt-2\">{{ property['no_apartment'] }}</p>\r\n                    </li>\r\n                    <li v-if=\"check_enabled('no_shop') && property['no_shop'] > 0\" class=\"priceBedRangeInfoInnerContainer\">\r\n                        <p class=\"\">{{ helper.t(\"Shops/Offices\") }}</p>\r\n                        <p class=\"fw-bold mt-2\">{{ property['no_shop'] }}</p>\r\n                    </li>\r\n                    <li v-if=\"property['ad_type'] == 'Rent'\" class=\"priceBedRangeInfoInnerContainer\">\r\n                        <p class=\"\">{{ helper.t(\"Rent Type\") }}</p>\r\n                        <p class=\"fw-bold mt-2\">{{ helper.t(property['rent_type']) }}</p>\r\n                    </li>\r\n                    <li  v-if=\"property['ad_type'] == 'Rent'\" class=\"priceBedRangeInfoInnerContainer\">\r\n                        <p class=\"\">{{ helper.t(\"Yearly Rent\") }}</p>\r\n                        <p class=\"fw-bold mt-2\">{{ property[\"yearly_price\"].toFixed(0) }}</p>\r\n                    </li>\r\n                    <li  v-else class=\"priceBedRangeInfoInnerContainer\">\r\n                        <p class=\"\">{{ helper.t(\"Total Price\") }}</p>\r\n                        <p class=\"fw-bold mt-2\">{{ property[\"total_price\"].toFixed(0) }}</p>\r\n                    </li>\r\n                    <li v-if=\"check_enabled('no_bed') && property['no_bed'] > 0\" class=\"priceBedRangeInfoInnerContainer\">\r\n                        <p class=\"\">{{ helper.t(\"Bedrooms\") }}</p>\r\n                        <p class=\"fw-bold mt-2\">{{ property['no_bed'] }}</p>\r\n                    </li>\r\n                    <li v-if=\"check_enabled('no_bath') && property['no_bath'] > 0\" class=\"priceBedRangeInfoInnerContainer\">\r\n                        <p class=\"\">{{ helper.t(\"Bathrooms\") }}</p>\r\n                        <p class=\"fw-bold mt-2\">{{ property['no_bath'] }}</p>\r\n                    </li>\r\n                    <li v-if=\"check_enabled('no_living') && property['no_living'] > 0\" class=\"priceBedRangeInfoInnerContainer\">\r\n                        <p class=\"\">{{ helper.t(\"Livingrooms\") }}</p>\r\n                        <p class=\"fw-bold mt-2\">{{ property['no_living'] }}</p>\r\n                    </li>\r\n                    <li v-if=\"check_enabled('for_type') && property['for_type']\" class=\"priceBedRangeInfoInnerContainer\">\r\n                        <p class=\"\">{{ helper.t(\"Property for\") }}</p>\r\n                        <p class=\"fw-bold mt-2\">{{ helper.t(property['for_type']=='Single'?'Singles':property['for_type']) }}</p>\r\n                    </li>\r\n                </template>\r\n            </ul>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\n    import * as global from \"../../js/global\" ;\r\n    import * as helper from \"../../js/helper\";\r\n\timport like_component from \"../components/like-component.vue\";\r\n    export default{\r\n        components: {\r\n        },\r\n\t\tname:'property_information_component',\r\n        props: {\r\n            property_json: {\r\n                type: String,\r\n            },\r\n            property_data: {\r\n                type: Object,\r\n            },\r\n        },\r\n\t\tdata() {\r\n\t\t\treturn {\r\n                global,\r\n                helper,\r\n                frappe,\r\n                is_loading: false,\r\n                property: null,\r\n                ad_type_color: '#0000ff',\r\n                ad_type_color_wt: '#0000ff',\r\n                property_type_icon: '#0000ff',\r\n                creation_date: new Date(),\r\n\t\t\t};\r\n\t\t},\r\n        mounted(){\r\n            if(this.property_json != undefined)\r\n                this.property = JSON.parse(this.property_json);\r\n            else\r\n                this.property = this.property_data;\r\n            this.is_loading = true;\r\n            this.creation_date = new Date(this.property.creation);\r\n            this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];\r\n            this.ad_type_color_wt = global.global_params.ad_type_colors[this.property.ad_type]+\"aa\";\r\n            this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];\r\n            this.is_loading = false;\r\n        },\r\n\t\tmethods: {\r\n\t\t\tcheck_enabled: function(field){\r\n\t\t\t\tif (this.property.property_type==\"\")\r\n\t\t\t\t\treturn false;\r\n\t\t\t\treturn this.enabled_fields.includes(field);\r\n\t\t\t},\r\n            year_string: function(year_count){\r\n                if(year_count == 0) return 'New';\r\n                else if(year_count == 1) return 'Year';\r\n                else if(year_count == 2) return '2 Years';\r\n                else if(year_count > 10) return '{0} Years_';\r\n                else return '{0} Years';\r\n            }\r\n\t\t},\r\n\t\tcomputed:{\r\n            enabled_fields(){\r\n                var fields = global.property_constants.property_types[this.property.property_type];\r\n                global.property_constants.remove_field[this.property.ad_type].forEach(field => {\r\n                    const index = fields.indexOf(field);\r\n                    if (index > -1) { // only splice array when item is found\r\n                        fields.splice(index, 1); // 2nd parameter means remove one item only\r\n                    }\r\n                });\r\n                if(this.is_child){\r\n                    global.property_constants.remove_child_field.forEach(field => {\r\n                        const index = fields.indexOf(field);\r\n                        if (index > -1) { // only splice array when item is found\r\n                            fields.splice(index, 1); // 2nd parameter means remove one item only\r\n                        }\r\n                    });\r\n                }\r\n                return fields;\r\n            }\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n    .icon{\r\n        width:10%;\r\n    }\r\n    .properties-img .image-holder{\r\n        display: block;\r\n        padding-top: 100%;\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/components/property-information-component.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__